import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "../app/store/configureStore";
import { userHelpers } from "../app/helpers/userHelpers";
import Alert from "./Alert";

const StudentSeasonAlerts: React.FC = () => {
  const { t } = useTranslation();
  const isStudent = userHelpers.isStudent();
  const noStudentAgreement = useSelector((state: RootState) => !state.currentUser.seasonInfo?.agreementApproved);
  const applicationsLimitExceeded = useSelector(
    (state: RootState) => !!state.currentUser.seasonInfo?.applicationsLimitExceeded
  );
  const schoolHadNoTraining = useSelector((state: RootState) => !!state.currentUser.seasonInfo?.schoolHadNoTraining);

  if (!isStudent) return null;

  return (
    <>
      {noStudentAgreement && (
        <Alert type="warning" header={t("applications.student.agreementNeededHeader")}>
          <Trans i18nKey="applications.student.agreementNeeded" components={{ profile: <Link to="/profile" /> }} />
        </Alert>
      )}
      {applicationsLimitExceeded && <Alert type="warning">{t("applications.student.limitExceeded")}</Alert>}
      {schoolHadNoTraining && (
        <Alert type="warning" header={t("applications.student.schoolHadNoTrainingHeader")}>
          {t("applications.student.schoolHadNoTrainingBody")}
        </Alert>
      )}
    </>
  );
};

export default StudentSeasonAlerts;
